import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import "@wmart/design-tokens/tokens.css";
import "./index.css";
import { App } from "./App.js";

// Sentry init runs before `createRoot` so React errors thrown during the
// initial render are captured. Vite bakes `VITE_*` env vars into the bundle
// at build time, so the DSN must be available when `vite build` runs — set
// it in CI before invoking the build. Gated by presence so dev builds
// without a DSN don't ship telemetry (L83). Release tag is the build-time
// Cloud Run revision name surfaced via VITE_SENTRY_RELEASE (L84).
// tracesSampleRate=0 → errors only for V1.0; OTel traces deferred to V1.5
// per arch §13.3.
if (import.meta.env["VITE_SENTRY_DSN"]) {
  Sentry.init({
    dsn: import.meta.env["VITE_SENTRY_DSN"],
    environment:
      import.meta.env["VITE_SENTRY_ENVIRONMENT"] ?? "development",
    release: import.meta.env["VITE_SENTRY_RELEASE"],
    tracesSampleRate: 0,
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
